import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect, useContext } from "react";
import CardSentenciado from "../components/cards/CardSentenciado";
import ModalCandidato from "./ModalCandidato";
import FiltersCandidato from "./FiltersCandidato";
import Navigation from "./general/Navigation";
import { MyContext } from "../components/Context.js";
import { Link } from "react-router-dom";

function CandidatosDemandas({ currentRegion }) {
  const context = useContext(MyContext);

  const [showModal, setShowModal] = useState(false);
  const [currentCandidato, setCurrentCandidato] = useState(null);
  const [initialSentencias, setInitialSentencias] = useState([]); // Data inicial
  const [filterSentencias, setFilterSentencias] = useState([]); // Data inicial
  const [displayList, setDisplayList] = useState([]);
  const [listCandidatos, setListCandidatos] = useState([]);
  const [listUbicacion, setListUbicacion] = useState([]);
  const [currentUbicacion, setCurrentUbicacion] = useState({
    region: null,
    provincia: null,
    distrito: null,
  });

  const [paginationOptions, setPaginationOptions] = useState({
    currentPage: 0,
    totalPages: 0,
  });

  useEffect(() => {
    const refreshRegion = (currentRegion) => {
      setCurrentUbicacion({
        region: currentRegion,
        provincia: null,
        distrito: null,
      });
      setDisplayList(initialSentencias.slice(0, 10));
      setFilterSentencias(initialSentencias);
      setPaginationOptions({
        currentPage: 1,
        totalPages: Math.ceil(initialSentencias.length / 10),
      });
    };
    refreshRegion(currentRegion);
  }, [currentRegion, initialSentencias]);

  // Armar arreglo de ubicacion
  const setUbicacionJson = (array) => {
    let uniqueRegion = [...new Set(array.map((i) => i.region))]
      .filter((f) => f)
      .sort();
    return uniqueRegion.map(region => ({ 'region': region }));
  };

  useEffect(() => {
    if (context.candidatos) {
      // Data inicial
      const candidatosInvestigados = context.candidatos;
      setInitialSentencias(candidatosInvestigados);
      setFilterSentencias(candidatosInvestigados);

      // Regiones
      const ubicacion = setUbicacionJson(candidatosInvestigados);
      setListUbicacion(ubicacion);

      // Ranking 10
      setDisplayList(candidatosInvestigados.slice(0, 10));

      // Lista de nombres de candidatos
      setListCandidatos([
        { value: "Todos", label: "--Todos--" },
        ...new Set(
          candidatosInvestigados.map((item) => ({
            value: item.candidato,
            label: item.candidato,
          }))
        ),
      ]);

      // Pagination
      setPaginationOptions({
        currentPage: 1,
        totalPages: Math.ceil(candidatosInvestigados.length / 10),
      });
    }
  }, [context.candidatos]);

  useEffect(() => {
    function handleEscapeKey(event) {
      if (event.key === "Escape") {
        setShowModal(false);
      }
    }

    document.addEventListener("keydown", handleEscapeKey);
    return () => document.removeEventListener("keydown", handleEscapeKey);
  }, []);

  // Manejar click en fila
  const handleClick = (dni) => {
    const candidato = initialSentencias.find((f) => f.dni === dni);
    setCurrentCandidato(candidato);
    setShowModal(true);
  };



  // Pagination
  const changePage = (page) => {
    let startPage = page * 10;
    let endPage = (page + 1) * 10;
    setDisplayList(filterSentencias.slice(startPage, endPage));
    console.log('startPage',startPage,'endPage', endPage)
    setPaginationOptions({ ...paginationOptions, currentPage: page + 1 });
  };


  const validateUbicacion = (sentencias) => {
    return sentencias.filter((f) => {
      let returnItem = true;
   
      if (currentUbicacion.region && f.region !== currentUbicacion.region) {
        returnItem = false;
      }
      return returnItem;
    });
  };

  // Handle change ubicacion
  useEffect(() => {
    console.log('entra aqui 1')
    if (initialSentencias) {
  
      let filterList = [];  

      if (currentUbicacion.region === "Todos") {
        filterList = initialSentencias;
        setCurrentUbicacion({ region: null });
      }

      if (
        currentUbicacion.region !== "Todos"
      ) {
        filterList = validateUbicacion(initialSentencias);
      }

      setDisplayList(filterList.slice(0, 10));
      setFilterSentencias(filterList);

      setPaginationOptions({
        currentPage: 1,
        totalPages: Math.ceil(filterList.length / 10),
      });
    }
  }, [currentUbicacion, initialSentencias]);


  // Validar otros filtros a aplicar
  const validateFilters = (filtros) => {
    let sentencias = initialSentencias;
    filtros.forEach((f) => {
      if (
        f === "ubicacion" &&
        (currentUbicacion.region)
      ) {
        sentencias = validateUbicacion(sentencias);
      }
    });
    return sentencias;
  };

  const handleCandidato = (option) => {
    let candidatos =
      option.value === "Todos"
        ? initialSentencias
        : initialSentencias.filter((f) => f.candidato === option.value);
    setFilterSentencias(candidatos);
    setDisplayList(candidatos.slice(0, 10));
    setPaginationOptions({
      currentPage: 1,
      totalPages: Math.ceil(candidatos.length / 10),
    });
  };

  const cleanSentenciados = () => {
    setFilterSentencias(initialSentencias);
    setDisplayList(initialSentencias.slice(0, 10));
    setPaginationOptions({
      currentPage: 1,
      totalPages: Math.ceil(initialSentencias.length / 10),
    });
    setCurrentUbicacion({ region: null });
  };

  return (
    <>
      <div className="CandidatosDemandas">
        {context.candidatos
          ? context.candidatos.map((c, idx) => (
              <Link to={"/" + c.slug} style={{ fontSize: "0" }} key={idx}>
                linkToStore
              </Link>
            ))
          : null}
        <div>
          <div className="container ">
            <div className="row align-items-center align-content-start mb-4">
              <div className="col-8">
                <FiltersCandidato
                  listCandidatos={listCandidatos}
                  listUbicacion={listUbicacion}
                  currentUbicacion={currentUbicacion}
                  setCurrentUbicacion={setCurrentUbicacion}
                  handleCandidato={handleCandidato}
                />
              </div>
              <div className="col-4">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={cleanSentenciados}
                >
                  Limpiar filtros
                </button>
              </div>
            </div>

            {displayList.length ? (
              <div className="table-responsive">
                <table className="table table-hover table-sm">
                  <thead>
                    <tr>
                    <th scope="col" className="text-left">Año</th>
                      <th scope="col" className="text-left">Sancionado</th>
                      <th scope="col" className="text-left">
                        Cargo funcional
                      </th>
                      <th scope="col" className="text-left">
                        Región
                      </th>
                      <th scope="col">Decisión final</th>
                     
                      <th scope="col" className="text-left">
                        Estado
                      </th>
                     
                      
                    </tr>
                  </thead>
                  <tbody>
                    {displayList.map((sentencia, index) => (
                      <CardSentenciado
                        sentencia={sentencia}
                        key={sentencia.candidato+sentencia.dni + sentencia.year}
                        handleClick={handleClick}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="container">Sin resultados.</div>
            )}

            <div>
              <Navigation
                paginationOptions={paginationOptions}
                changePage={changePage}
              />
            </div>
          </div>
        </div>

        <br></br>
        <br></br>
      </div>
      {showModal && (
        <ModalCandidato
          currentCandidato={currentCandidato}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
}

export default CandidatosDemandas;
